import Handlebars from 'handlebars';
import Swiper from 'swiper/swiper-bundle.js';

import { animateScrollRevealMixinBlock } from '../../mixins/animateScrollRevealMixinBlock/animateScrollRevealMixinBlock';
import { ProgressRadialCheckWidget } from '../../../widgets/progressRadialCheckWidget/js/progressRadialCheckWidget';
import { ProgramCoursesListWidget } from '../../../widgets/programCoursesListWidget/js/programCoursesListWidget';
import { ProgramCoursesItemWidget } from '../../../widgets/programCoursesItemWidget/js/programCoursesItemWidget';
import { ProgressBarWidget } from '../../../widgets/progressBarWidget/js/progressBarWidget';
import { ifCond } from '../../../../../handlebarsHelpers';

const NS = 'ProgramsWideCarouselBlock';
const CLS = 'programsWideCarouselBlock';

export class ProgramsWideCarouselBlock {
	constructor(element) {
		const $this = this;

		this.element = element;
		this.$element = $(element);

		this.$tplScroller = $('.tpl-scroller');
		this.isLoggedIn = this.$element.data('loggedIn');
		this.registerUrl = this.$element.data('registerUrl');
		this.loginUrl = this.$element.data('loginUrl');
		this.api = this.$element.attr('data-api');
		this.selectedClass = 'selected';
		this.$courseContainer = $(`#programCoursesContainer${NS}`);
		this.$courseSelectedId = null;

		this.$swiper = this.$element.find(`.${CLS}-swiper`);
		this.$buttonNext = this.$element.find(`.${CLS}-swiper-button-next`);
		this.$buttonPrev = this.$element.find(`.${CLS}-swiper-button-prev`);
		this.$initialSlide = 0;

		// Load Templates (existing)
		this.loadTemplates();

		// Carousel (new - as it is looping and centered, it has different setup to other carousels)
		this.$swiperObj = new Swiper(this.$swiper[0], {
			speed: 700,
			spaceBetween: 0,
			slidesPerView: 'auto', // scroll 3 at a time instead of 1
			autoHeight: false,
			shortSwipes: true,
			slideToClickedSlide: true,
			centeredSlides: true,
			loop: false,
			loopedSlidesLimit: true,
			navigation: {
				nextEl: this.$buttonNext[0],
				prevEl: this.$buttonPrev[0]
			},
			initialSlide: 1,
			on: {
				init: function() {					
				}
			}
		});

		// Scroll animation
		this.initAnimateScrollReveal(this, CLS);
		this.$element.find(`.card-program-arrow`).hide();		
	}

	// Load Templates (existing)
	loadTemplates() {
		let programCoursesContentWidget = require('../../../widgets/programCoursesContentWidget/tmpl/programCoursesContentWidget.hbs');
		Handlebars.registerPartial('programCoursesContentWidget', programCoursesContentWidget);

		let programCoursesOverviewWidget = require('../../../widgets/programCoursesOverviewWidget/tmpl/programCoursesOverviewWidget.hbs');
		Handlebars.registerPartial('programCoursesOverviewWidget', programCoursesOverviewWidget);

		let programCoursesListWidget = require('../../../widgets/programCoursesListWidget/tmpl/programCoursesListWidget.hbs');
		Handlebars.registerPartial('programCoursesListWidget', programCoursesListWidget);

		let programCoursesItemWidget = require('../../../widgets/programCoursesItemWidget/tmpl/programCoursesItemWidget.hbs');
		Handlebars.registerPartial('programCoursesItemWidget', programCoursesItemWidget);

		let progressBarWidget = require('../../../widgets/progressBarWidget/tmpl/progressBarWidget.hbs');
		Handlebars.registerPartial('progressBarWidget', progressBarWidget);

		let progressRadialCheckWidget = require('../../../widgets/progressRadialCheckWidget/tmpl/progressRadialCheckWidget.hbs');
		Handlebars.registerPartial('progressRadialCheckWidget', progressRadialCheckWidget);

		let template = `
			{{> programCoursesContentWidget
				wg="programCoursesContentWidget"
				ns="ProgramCoursesContentWidget"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.programCoursesContentWidgetRenderer = Handlebars.template(precompiled);

		Handlebars.registerHelper('ifCond', ifCond);
	}

	// Set Selected Course (existing)
	setSelectedCourse(id) {
		if(this.$courseSelectedId !== id) {
			this.$courseSelectedId = id;
			const params = `?id=${id}`;

			fetch(this.api + params)
				.then((response) => response.json())
				.then((json) => {
					let programCoursesContentWidgetModel = {
						isLoggedIn: this.isLoggedIn,
						registerUrl: this.registerUrl,
						loginUrl: this.loginUrl,
						// rippleSrc: this.rippleSrc,
						program: json,
						programCoursesOverviewWidget: {
							wg: 'programCoursesOverviewWidget',
							ns: 'ProgramCoursesOverviewWidget'
						},
						programCoursesListWidget: {
							wg: 'programCoursesListWidget',
							ns: 'ProgramCoursesListWidget',
							programCoursesItemWidget: {
								wg: 'programCoursesItemWidget',
								ns: 'ProgramCoursesItemWidget',
								progressBarWidget: {
									wg: 'progressBarWidget',
									ns: 'ProgressBarWidget'
								},
								progressRadialCheckWidget: {
									wg: 'progressRadialCheckWidget',
									ns: 'ProgressRadialCheckWidget'
								}
							}
						}
					};

					this.$courseContainer.html(this.programCoursesContentWidgetRenderer(programCoursesContentWidgetModel));

					let $programCoursesListWidget = this.$courseContainer.find(`[data-wg="ProgramCoursesListWidget"]`);
					if($programCoursesListWidget && $programCoursesListWidget.length > 0) {
						new ProgramCoursesListWidget($programCoursesListWidget[0]);

						let $programCoursesItemWidget = $programCoursesListWidget.find(`[data-wg="ProgramCoursesItemWidget"]`);

						if($programCoursesItemWidget && $programCoursesItemWidget.length > 0) {
							$programCoursesItemWidget.each((index, element) => {
								let $course = $(element);
								new ProgramCoursesItemWidget($course[0]);

								let $progressBarWidget = $course.find('[data-wg="ProgressBarWidget"]');
								if($progressBarWidget[0]) {
									new ProgressBarWidget($progressBarWidget[0]);
								}

								let $progressRadialCheckWidget = $course.find('[data-wg="ProgressRadialCheckWidget"]');
								if($progressRadialCheckWidget[0]) {
									new ProgressRadialCheckWidget($progressRadialCheckWidget[0]);
								}
							});
						}
					}
				}
			);
		}
	}
}

Object.assign(ProgramsWideCarouselBlock.prototype, animateScrollRevealMixinBlock);
